import shareOrder from './modules/share-order';
import jdFinance from './modules/jd-finance';
import { dateFtt } from '@/utils/common';

export default {
	namespaced: true,
	state: () => ({
		wdClickCount: 0,
		userVipInfo: {
			date: '2020.10.30 12:34:56',
			isOpen: false,
		},
		withdrawTicketsInfo: {},
	}),
	mutations: {
		setWdClickCount(state, data) {
			state.wdClickCount = state.wdClickCount + data;
		},
		setUserVipInfo(state, data) {
			data.expire_time && (data.expire_time = dateFtt('yyyy-MM-dd', new Date(data.expire_time * 1000)));
			data.effective_time && (data.effective_time = dateFtt('yyyy-MM-dd', new Date(data.effective_time * 1000)));
			data.is_valid && (data.is_valid = data.is_valid === 1);
			state.userVipInfo = data;
		},
		setWithdrawTicketsInfo(state, data) {
			state.withdrawTicketsInfo = data;
		},
	},
	actions: {
		updateWdClickCount({ commit }, data) {
			commit('setWdClickCount', data);
		},
	},
	getters: {
		wdClickCount: (state) => {
			return state.wdClickCount;
		},
		userVipInfo: (state) => {
			return state.userVipInfo;
		},
		withdrawTicketsInfo: (state) => {
			return state.withdrawTicketsInfo;
		},
	},

	//	嵌套模块,继承父模块的命名空间
	modules: {
		shareOrder,
		jdFinance,
	},
};



// WEBPACK FOOTER //
// ./src/store/Withdraw/index.js